import React from "react";

const Modal = props => (
  <div className="modal">
    <div className="modal-cont">{props.children}</div>
  </div>
);

export default Modal;
